module.exports = __webpack_public_path__ + "static/img/ftpresentation.8ac1446.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/ftpresentation.png
// module id = iSvF
// module chunks = 0